// redux/slices/adminUsersSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
};

const adminUsersSlice = createSlice({
  name: "adminUsers",
  initialState,
  reducers: {
    setAdminUsers(state, action) {
      state.users = action.payload || [];
    },
  },
});

export const {
  setAdminUsers
} = adminUsersSlice.actions;

export default adminUsersSlice.reducer;